module.exports = __webpack_public_path__ + "static/avatar-f1d71f777331fd7e3de116edf4ee3b67.jpg";